import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'
import { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { ADMIN_ROUTES } from 'src/constants/routes'
import { useHasPermission } from 'src/hooks/useHasPermission'

interface Props {
  onRefresh(): void
}

const InternalRolesToolbarComponent = ({ onRefresh }: Props) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const canManage = useHasPermission(InternalPermission.InternalRolesManage)

  // The query string rides along so the editor's Back lands on this tab.
  const handleCreateClick = useCallback(() => {
    navigate({
      pathname: ADMIN_ROUTES.USERS_MANAGEMENT_NEW_ROLE_URL,
      search: searchParams.toString(),
    })
  }, [navigate, searchParams])

  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`}
    >
      <div css={tw`ml-auto flex flex-row items-center gap-2`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="internal-roles-refresh-button"
        >
          Refresh
        </Button>
        {canManage ? (
          <Button
            size="small"
            color="dark"
            leftIcon={<GSIcon iconName="gs_plus_medium" size={20} css={tw`text-shades-0`} />}
            onClick={handleCreateClick}
            data-testid="internal-roles-create-button"
          >
            Create role
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export const InternalRolesToolbar = memo(InternalRolesToolbarComponent)
